export const openChange = (value, index, questionId) => ({
  type: 'OPEN_CHANGE',
  index,
  questionId,
  value,
});

export const matrixChange = (value, rowIndex, fieldIndex, questionId) => ({
  type: 'OPEN_MATRIX_UPDATE',
  fieldIndex,
  questionId,
  rowIndex,
  value,
});

export const openMatrixBlur = (rowIndex, fieldIndex, questionId) => ({
  type: 'OPEN_MATRIX_BLUR',
  fieldIndex,
  questionId,
  rowIndex,
});
